import React from 'react'

import { BUTTON_THEME, Button } from '@st-operations/uikit/src/v2/index.js'

import './styles.scss'

const ConfirmationModal = ({
  onConfirm,
  onCancel,
  data: { title, description, confirmButtonText, cancelButtonText },
}) => {
  return (
    <section className="omm-confirmation-modal">
      <h2>{title}</h2>
      {description.map((item, index) => (
        <p key={index}>{item}</p>
      ))}
      <div className="mt-4 flex justify-center">
        <Button
          className="st-new-entity-modal__button"
          onClick={onCancel}
          theme={BUTTON_THEME.SECONDARY}
        >
          {cancelButtonText}
        </Button>
        <Button className="st-new-entity-modal__button" onClick={onConfirm}>
          {confirmButtonText}
        </Button>
      </div>
    </section>
  )
}

export default ConfirmationModal
